export default __webpack_public_path__ + "static/media/effigaz.e79d3cfa.svg";